import { registerEnumType } from 'type-graphql'

export enum SchoolInviteStatusEnum {
  Outstanding = 'Outstanding',
  Redeemed = 'Redeemed',
  Expired = 'Expired',
}

registerEnumType(SchoolInviteStatusEnum, {
  name: 'SchoolInviteStatusEnum',
  description: 'Derived status of a school invite — never persisted, computed from redeemedAt/expiresAt',
})
